function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { css } from '@emotion/react';
import { rem } from './../../../styles';
var _ref = process.env.NODE_ENV === "production" ? {
  name: "x3muxe",
  styles: ">div{bottom:0;left:0;position:absolute;width:100%;}"
} : {
  name: "fj34ia-StickyPortalStyles",
  styles: ">div{bottom:0;left:0;position:absolute;width:100%;};label:StickyPortalStyles;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "duudsh",
  styles: "position:fixed"
} : {
  name: "1fxrubd-StickyPortalStyles",
  styles: "position:fixed;label:StickyPortalStyles;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var StickyPortalStyles = function StickyPortalStyles(_ref3) {
  var bottom = _ref3.bottom,
    isAttachedToBody = _ref3.isAttachedToBody,
    portalContainerClass = _ref3.portalContainerClass,
    stickToBottom = _ref3.stickToBottom,
    stickyPositionTop = _ref3.stickyPositionTop;
  // styles to be applied to Portal container
  var bottomStyle = bottom === 'auto' ? 0 : rem(bottom);
  return /*#__PURE__*/css(".", portalContainerClass, "{left:0;width:100%;", stickToBottom ? /*#__PURE__*/css("bottom:", bottomStyle, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:StickyPortalStyles;")) : /*#__PURE__*/css("top:", rem(stickyPositionTop), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:StickyPortalStyles;")), ";", isAttachedToBody ? _ref2 : /*#__PURE__*/css("height:0;position:sticky;", stickToBottom && _ref, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:StickyPortalStyles;")), ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:StickyPortalStyles;"));
};
export default StickyPortalStyles;